import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { statsManager } from '../utils/stats';

export function Home() {
  const navigate = useNavigate();
  const [stats, setStats] = useState(statsManager.getStats());

  useEffect(() => {
    // Refresh stats when component mounts
    setStats(statsManager.getStats());
  }, []);

  const winRate = statsManager.getWinRate();

  return (
    <div className="min-h-screen bg-black text-[#e0e0e0] flex flex-col items-center justify-center p-4">
      <div className="max-w-4xl w-full space-y-8">
        {/* Header */}
        <div className="text-center space-y-4">
          <h1 className="text-6xl font-bold text-[#00ff41] viper-glow font-mono">
            V7P3R.LABS
          </h1>
          <p className="text-xl text-gray-400">
            Challenge the V7P3R Chess Engine
          </p>
        </div>

        {/* Stats Board */}
        <div className="viper-card">
          <h2 className="text-2xl font-bold text-[#00ff41] mb-6 font-mono">
            // COMMUNITY SCOREBOARD
          </h2>
          
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
            <div className="text-center p-4 bg-[#1a1a1a] rounded">
              <div className="text-3xl font-bold text-[#00ff41]">
                {stats.gamesPlayed}
              </div>
              <div className="text-sm text-gray-400 mt-1">Games Played</div>
            </div>
            
            <div className="text-center p-4 bg-[#1a1a1a] rounded">
              <div className="text-3xl font-bold text-green-500">
                {stats.wins}
              </div>
              <div className="text-sm text-gray-400 mt-1">Human Wins</div>
            </div>
            
            <div className="text-center p-4 bg-[#1a1a1a] rounded">
              <div className="text-3xl font-bold text-red-500">
                {stats.losses}
              </div>
              <div className="text-sm text-gray-400 mt-1">V7P3R Wins</div>
            </div>
            
            <div className="text-center p-4 bg-[#1a1a1a] rounded">
              <div className="text-3xl font-bold text-yellow-500">
                {stats.draws}
              </div>
              <div className="text-sm text-gray-400 mt-1">Draws</div>
            </div>
          </div>

          {stats.gamesPlayed > 0 && (
            <div className="mt-6 text-center">
              <div className="text-lg text-gray-400">
                Human Win Rate:{' '}
                <span className="text-[#00ff41] font-bold">
                  {winRate.toFixed(1)}%
                </span>
              </div>
            </div>
          )}
        </div>

        {/* Game Info */}
        <div className="viper-card space-y-4">
          <h2 className="text-2xl font-bold text-[#00ff41] mb-4 font-mono">
            // GAME SETUP
          </h2>
          
          <div className="space-y-2 text-gray-300">
            <div className="flex justify-between py-2 border-b border-[#1a1a1a]">
              <span className="text-gray-400">Engine Version:</span>
              <span className="font-semibold">V7P3R v18.4</span>
            </div>
            <div className="flex justify-between py-2 border-b border-[#1a1a1a]">
              <span className="text-gray-400">Time Control:</span>
              <span className="font-semibold">10+0 (10 minutes)</span>
            </div>
            <div className="flex justify-between py-2 border-b border-[#1a1a1a]">
              <span className="text-gray-400">Color:</span>
              <span className="font-semibold">Random</span>
            </div>
            <div className="flex justify-between py-2">
              <span className="text-gray-400">Max Game Time:</span>
              <span className="font-semibold">20 minutes</span>
            </div>
          </div>
        </div>

        {/* Start Button */}
        <div className="text-center">
          <button
            onClick={() => navigate('/play')}
            className="viper-button text-xl px-12 py-4"
          >
            START GAME
          </button>
        </div>

        {/* Footer */}
        <div className="text-center text-gray-600 text-sm">
          <p>
            Powered by V7P3R Chess Engine •{' '}
            <a
              href="https://lichess.org/@/v7p3r_bot"
              target="_blank"
              rel="noopener noreferrer"
              className="text-[#00ff41] hover:underline"
            >
              Play on Lichess
            </a>
          </p>
        </div>
      </div>
    </div>
  );
}
